import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../../http.service';
import { ProductService } from '../product.service';
import { GlobalService } from '../../global.service';

@Component({
  selector: 'app-product-register',
  templateUrl: './product-register.component.html',
  styleUrls: ['./product-register.component.scss']
})
export class ProductRegisterComponent {

  product_register_form: FormGroup;
  action: 'register' | 'update' = null;
  product_group: ProductGroup[] = [];
  product_units: ProductUnit[] = [];
  edit_short_name = false;
  constructor(private http: HttpService, public productService: ProductService, private formBuilder: FormBuilder, private global: GlobalService) {
    this.product_register_form = this.formBuilder.group({
      id: [null, Validators.compose([])],
      group_id: [null, Validators.compose([Validators.required])], // product group id
      unit_id: [null, Validators.compose([Validators.required])],
      name: [null, Validators.compose([Validators.required])],
      short_name: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      quantity: [null, Validators.compose([Validators.required])],
      base_price: [null, Validators.compose([Validators.required])],
      gst_percent: [null, Validators.compose([Validators.required])],
      mrp: [null],
      snf: [null],
      fat: [null],
      is_homogenised: [false],
      description: [null, Validators.compose([Validators.required])],
      pvt_discount_price: [null, Validators.compose([Validators.required])],
      gvt_discount_price: [null, Validators.compose([Validators.required])],
      society_price: [null, Validators.compose([])],
    });

    if (this.productService.get_product_data === null) {
      this.action = 'register';
      this.edit_short_name = false;
    } else {
      this.action = 'update';
      this.edit_short_name = true;
      this.setupUpdateForm(this.productService.get_product_data);
    }

    this.productService.productUpdate.subscribe((zone) => {
      if (zone === null) {
        this.action = 'register';
        this.edit_short_name = false;
        this.product_register_form.reset();
      } else {
        this.action = 'update';
        this.edit_short_name = true;
        this.setupUpdateForm(zone);
      }
    });
    this.getCvs();
  }


  getCvs() {
    // get product group
    this.http.getProductGroup().subscribe((data: ProductGroup[]) => {
      console.log(data);
      this.product_group = data;
    }, (error) => {
      console.log(error);
    });

    // get product unit
    this.http.getProductUnit().subscribe((data: ProductUnit[]) => {
      console.log(data);
      this.product_units = data;
    }, (error) => {
      console.log(error);
    });
  }

  registerProduct() {
    this.http.saveProduct(this.product_register_form.value).subscribe((data) => {
      this.global.showSnakeBar(data['message']);
      this.product_register_form.reset();
      this.productService.downloadProduct.emit(true);
      this.productService.is_display_product_register_component = false;
    }, (error) => {
      console.log(error);
    });
  }

  setupUpdateForm(product) {
    console.log(product);
    this.product_register_form.controls['id'].setValue(product['id']);
    this.product_register_form.controls['name'].setValue(product['name']);
    this.product_register_form.controls['group_id'].setValue(product['group_id']);
    this.product_register_form.controls['unit_id'].setValue(product['unit_id']);
    this.product_register_form.controls['code'].setValue(product['code']);
    this.product_register_form.controls['short_name'].setValue(product['short_name']);
    this.product_register_form.controls['quantity'].setValue(product['quantity']);
    this.product_register_form.controls['mrp'].setValue(product['mrp']);
    this.product_register_form.controls['base_price'].setValue(product['base_price']);
    this.product_register_form.controls['snf'].setValue(product['snf']);
    this.product_register_form.controls['fat'].setValue(product['fat']);
    this.product_register_form.controls['is_homogenised'].setValue(product['is_homogenised']);
    this.product_register_form.controls['gst_percent'].setValue(product['gst_percent']);
    this.product_register_form.controls['description'].setValue(product['description']);
    this.product_register_form.controls['pvt_discount_price'].setValue(product['private_institute_price']);
    this.product_register_form.controls['gvt_discount_price'].setValue(product['govt_institute_price']);
    this.product_register_form.controls['society_price'].setValue(product['society_price']);
  }

}

interface ProductGroup {
  id: number;
  name: string;
}

interface ProductUnit {
  id: number;
  name: string;
}
